import React from "react"
import Markdown from "markdown-to-jsx"
import GalleryLink from "../../chat/SlickAIGalleryLink"
import { ListBlock } from "./types"
import { linkifyUrls } from "@/components/chat/SlickAIMessage"

export const ListRenderer = ({
  block,
  messageId,
  linkOverride,
}: {
  block: ListBlock
  messageId: string
  linkOverride?: React.ComponentType<{
    href: string
    children: React.ReactNode
  }>
}) => {
  const LinkComponent = linkOverride || GalleryLink
  return (
    <ul className="my-3 list-disc space-y-1 pl-6">
      {block.items.map((item, index) => (
        <li key={index}>
          <Markdown
            options={{
              overrides: {
                a: {
                  component: LinkComponent,
                  props: linkOverride ? {} : { messageId },
                },
              },
            }}
          >
            {linkifyUrls(item)}
          </Markdown>
        </li>
      ))}
    </ul>
  )
}
